import { ReactNode } from 'react';

import { RiAddLine } from '@remixicon/react';

import { Button } from '@spotify-internal/encore-web';

export type PageContentActionBarCreateButtonProps = {
  onClick: () => void;
  disabled?: boolean;
  isVisuallyDisabled?: boolean;
  'aria-disabled'?: boolean;
  'data-testid'?: string;
  children?: ReactNode;
};

export const ContentActionBarCreateButton = ({
  onClick,
  disabled,
  isVisuallyDisabled,
  'aria-disabled': ariaDisabled,
  children = 'Create',
  ...rest
}: PageContentActionBarCreateButtonProps) => (
  <Button
    variant="primary"
    onClick={ariaDisabled ? undefined : onClick}
    disabled={disabled}
    isVisuallyDisabled={isVisuallyDisabled}
    aria-disabled={ariaDisabled}
    {...rest}
  >
    <RiAddLine />
    {children}
  </Button>
);
